import {debounce, map, mapTo, mergeMap} from 'rxjs/operators';
import {timer, Observable, of} from "rxjs";
import {ofType, StateObservable} from 'redux-observable';
import {EVENT_NOTIFICATION_TYPE} from '../../helpers/EventNotificationType';
import {AppState} from "../../reducers/RootReducer";
import {createErrorResponse} from "../../config/languages/definitions/AjaxResponses";
import {currentLanguageFromStore} from "../../config/LanguageConfig";
import {fetchAuthenticatedUser} from "./AuthenticatedUserActions";

export const EVENT_NOTIFICATION_SHOW = 'EVENT_NOTIFICATION_SHOW';
export const EVENT_NOTIFICATION_HIDE = 'EVENT_NOTIFICATION_HIDE';

interface EventNotificationHideAction {
    type: typeof EVENT_NOTIFICATION_HIDE
}

interface EventNotificationShowAction {
    type: typeof EVENT_NOTIFICATION_SHOW
    messageType: EVENT_NOTIFICATION_TYPE
    message: string
    delay: number
}

export type EventNotificationActionTypes = EventNotificationHideAction | EventNotificationShowAction

export function eventNotificationHide()  {
    return { type: EVENT_NOTIFICATION_HIDE };
}

/**
 * redux function to display an notification for an event
 */
export function eventNotificationShow(
    messageType: EVENT_NOTIFICATION_TYPE,
    message: string = '',
    delay: number = 4000
) {
    return {
        type: EVENT_NOTIFICATION_SHOW,
        messageType: messageType,
        message,
        delay
    };
}

/**
 * redux event notification success shorthand for successful async fetching redux observable functions
 */
export function eventNotificationSuccess( message: string = '', delay: number = 4000 ) {
    return eventNotificationShow( EVENT_NOTIFICATION_TYPE.ajaxSuccess, message, delay);
}
/**
 * redux event notification error shorthand for failed async fetching redux observable functions
 */
export function eventNotificationError(
    error: any,
    store$: StateObservable< AppState >,
    view: string = "",
    methodName: string = "",
    delay: number = 4000
) {
    const language = currentLanguageFromStore( store$ );
    const message = createErrorResponse( language, error.status, view, methodName );
    return eventNotificationShow(EVENT_NOTIFICATION_TYPE.customAjaxError, message, delay)
}

export const eventNotificationEpic = ( action$: Observable< EventNotificationShowAction > ) =>
    action$.pipe(
        ofType(EVENT_NOTIFICATION_SHOW),
        debounce(action => timer(action.delay)),
        mergeMap( () => of(fetchAuthenticatedUser() )),
        map(() => eventNotificationHide()),
    );
